<div class="bar">
  <div class="fill" [class.empty]="value <= 5" [class.infinity]="!value" [style.width]="value+'%'">
    <div *ngIf="value !== null && showText" class="text">{{value}}%</div>
  </div>
</div>